/* global JSX */
/// <reference types="react-scripts" />
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { ICodeNameUrl } from "../../../models/common/codeNameUrl";
import * as frontService from "../../../models/services/frontService";
import { SectionIcon, SectionType } from "../../framework/Icon/SectionIcon";
import * as Styled from "./NavigationMenu.styles";

interface IExternalSystemDropdownProp {
    disabled?: boolean;
    text: string;
    intraModules: ICodeNameUrl[];
    intraRestModules: ICodeNameUrl[];
    externalSystems: ICodeNameUrl[];
}

export interface IExternalSystemDropdownState {
    editMode: boolean;
    items: JSX.Element[];
}

export const ExternalSystemDropdown = ({ externalSystems, intraModules, intraRestModules, text, disabled }: IExternalSystemDropdownProp) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [state, setState] = useState<IExternalSystemDropdownState | null>({
        editMode: false,
        items: [],
    });
    
    let dropdownId: string;

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };
  
    useEffect(() => {
        setState((old) => ({
            ...old,
            items: getItems({ intraModules, intraRestModules, externalSystems, text, disabled })
        }));
    }, [intraModules, intraRestModules, externalSystems, text]);

    const handleOtpLogin = async (ev: React.MouseEvent, url: string, code: string) => {
        ev.preventDefault();
        if (!code) return;
        const success = await frontService.getOtp(code);
        window.open(url + success.otp, "_blank");
    };

    const getItems = (props: IExternalSystemDropdownProp): JSX.Element[] => {
        const items: JSX.Element[] = [];
        for (const intraModule of props.intraModules) {
            items.push(<MenuItem key={intraModule.url} component="a" href={intraModule.url} title={intraModule.name} target="_blank" rel="noreferrer">{intraModule.name}</MenuItem>);
        }
        for (const intraModule of props.intraRestModules) {
            items.push(<MenuItem key={intraModule.url} onClick={(ev) => handleOtpLogin(ev, intraModule.url, intraModule.code) } title={intraModule.name}>{intraModule.name}</MenuItem>);
        }
        if (props.externalSystems.length > 0) {
            if (props.intraModules.length > 0 || props.intraRestModules.length > 0) {
                items.push(<Divider key='divider' />);
            }
            for (const intraModule of props.externalSystems) {
                items.push(<MenuItem key={intraModule.url} component="a" href={intraModule.url} title={intraModule.name} target="_blank" rel="noreferrer">{intraModule.name}</MenuItem>);
            }
        }
        return items;
    };

    return (
        <>
            <Styled.MenuItem data-id={dropdownId} title={text} onClick={handleClick} selected={open} disabled={disabled}>
                <ListItemIcon sx={{ color: open ? "primary.main" : "text.secondary", fontSize: ".5rem" }}><SectionIcon type={SectionType.ExternalSystems} /></ListItemIcon>
                <ListItemText primaryTypographyProps={{ variant: "body2", color: open ? "text.primary" : "text.secondary" }}>{text}</ListItemText>
            </Styled.MenuItem>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClick={handleClose}
                onClose={handleClose}
            >
                {state.items}
            </Menu>
        </>
    );
};